// App-side delegate for `@heidi/patients/data`.
// isAuthenticated crosses the package seam as a plain boolean; every
// call site keeps its exact signature.
import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';
import {
  GET_PATIENT_DOCUMENTS,
  useQueryPatientDocuments as useQueryPatientDocumentsCore,
} from '@heidi/patients/data';

export { GET_PATIENT_DOCUMENTS };

export function useQueryPatientDocuments(patientProfileId: string | null | undefined) {
  const { isAuthenticated } = useIsAuthenticated();

  return useQueryPatientDocumentsCore(patientProfileId, isAuthenticated);
}
